import { ChangeDetectionStrategy, Component, computed, inject, model, output, signal } from '@angular/core';
import { AbstractComponent, NoResultComponent } from '@spike/scaffolds';
import { OrderGeneralTogglePanel } from "../../panels/order-general-toggle-panel/order-general-toggle-panel";
import { WorkingPhaseTogglePanel } from "../../panels/working-phase-toggle-panel/working-phase-toggle-panel";
import { AsyncApiService, ResourceApiService } from '@spike/core';
import { PositionGeneralTogglePanel } from "../../panels/position-general-toggle-panel/position-general-toggle-panel";
import { WorkflowStepperComponent } from "../../../workflow/components/workflow-stepper/workflow-stepper";
import { WorkflowActionsComponent } from "../../../workflow/components/workflow-actions/workflow-actions";
import { Button } from "primeng/button";
import { WorkingPhaseGeneralTogglePanel } from "../../panels/working-phase-general-toggle-panel/working-phase-general-toggle-panel";
import { ShippingTogglePanel } from "../../panels/shipping-toggle-panel/shipping-toggle-panel";
import { Router } from '@angular/router';
import { ConfirmationDialogService } from '../../../shared/services/confirmation-dialog.service';
import { OrdineWorkflow, PositionWorkflow, PreventiveWorkflow, ProductionWorkflow, ProjectWorkflow, ShippingWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';
import { Order } from '../../models/order.model';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-order-page',
  imports: [OrderGeneralTogglePanel, WorkingPhaseTogglePanel, PositionGeneralTogglePanel, WorkflowStepperComponent, WorkflowActionsComponent, Button, WorkingPhaseGeneralTogglePanel, NoResultComponent, ShippingTogglePanel],
  templateUrl: './order-page.html',
  styleUrl: 'order-page.css'
})
export class OrderPageComponent extends AbstractComponent{

  // Inject
  private readonly resourceApi = inject(ResourceApiService);
  private readonly asyncApi = inject(AsyncApiService);
  private readonly router = inject(Router);
  private readonly confirmationDialogService = inject(ConfirmationDialogService);


  public readonly positionWorkflow = PositionWorkflow;
  public readonly preventiveWorkflow = PreventiveWorkflow;
  public readonly projectWorkflow = ProjectWorkflow;
  public readonly productionWorkflow = ProductionWorkflow;
  public readonly shippingWorkflow = ShippingWorkflow;
  public readonly ordineWorkflow = OrdineWorkflow;

  // Input
  orderId = model.required<number|undefined>();
  orderPage= model<number>(0);
  positionPage= model<number>(0);
  positionStatePage= model<number>(0);
  selectedPositionId = model<number|undefined>(undefined);

  // Output
  onSave = output<void>();
  back = output<void>();

  // State
  public readonly formViewSet = signal<{id: number, formView: boolean}[]>([]);

  public readonly isEditView = computed(()=> {
    const formViewSet = this.formViewSet();
    return formViewSet.some(x=> x.formView);
  })
  public readonly orderFilter = computed(()=> {
    const orderId= this.orderId();
    return orderId ? {id: orderId} as any : undefined;
  })

  public readonly orderResource = this.resourceApi.call<Order>(signal(EntityApiEnum.ORDER), signal('selectByIdFull' ), this.orderFilter);
  public readonly order = this.orderResource.value;

  public readonly selectedPosition = computed(()=>{
    const order = this.order();
    const selectedPositionId= this.selectedPositionId();
    let selected = undefined;
    if(order && selectedPositionId)
      selected = order?.positions?.find(x=> x.positionId== selectedPositionId);

    return selected;
  })

  public refresh(){
    this.orderResource.reload();
    this.onSave.emit();
  }

  public save(order?: Order){
    const orderId = this.orderId();
    if(!orderId && order && order.orderId){
      this.orderId.set(order.orderId)
    }else{
      this.orderResource.reload();
    }
    this.onSave.emit();
    
  }

  public async onDelete(){
    this.confirmationDialogService.show('Sei sicuro di voler eliminare questo ordine?', async () => {
      await this.delete();
    });
    
  }

  async delete(): Promise<void> {
    const orderId = this.orderId();
    if(orderId){
      await this.asyncApi.deleteById(EntityApiEnum.ORDER, orderId);
      this.onSave.emit();
      this.back.emit();
    } 
  }


    show() {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/external/scheda'], { queryParams: { orderId:this.orderId(), positionId: this.selectedPositionId() } })
      );
      window.open(url, '_blank');
    }


  public switchPosition(positionId?: number){
    this.formViewSet.set([]);
    this.selectedPositionId.set(positionId);
    this.positionStatePage.set(0);
  }

  public switchPositionStatePage(statePage: number){
    this.formViewSet.set([]);
    this.positionStatePage.set(statePage);
  }

  public switchOrderPage(orderPage: number){
    this.formViewSet.set([]);
    this.orderPage.set(orderPage);
  }


  updateFormViewSet(id:number, $event: boolean){
    const formViewSet = this.formViewSet();
    const formView = formViewSet.find(x => x.id === id);
    if(formView) {
      formView.formView = $event;
    }else{
      formViewSet.push({id, formView: $event});
    }
   this.formViewSet.set([...formViewSet]);
  }
}